import { render, staticRenderFns } from "./SyaratKetentuan.vue?vue&type=template&id=03fb8881&scoped=true&"
import script from "./SyaratKetentuan.vue?vue&type=script&lang=js&"
export * from "./SyaratKetentuan.vue?vue&type=script&lang=js&"
import style0 from "./SyaratKetentuan.vue?vue&type=style&index=0&id=03fb8881&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03fb8881",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VBtn,VCheckbox})
